import gql from 'graphql-tag'

export const GET_SHOP_QUERY = gql`
  query getShop($shopId: ID!) {
    shop(id: $shopId) {
      id
      name
      defaultCurrency
      defaultLanguage
      languages
      variants(shopId: $shopId) {
        edges {
          node {
            id
            sortOrder
            no
            title {
              id
              defaultValue
              text {
                langCode
                content
              }
            }
            type
            options {
              id
              sortOrder
              value
              title {
                id
                defaultValue
                text {
                  langCode
                  content
                }
              }
            }
          }
        }
      }
      productPackages(shopId: $shopId) {
        edges {
          node {
            id
            no
            meta
          }
        }
      }
    }
  }
`
export const GET_PRODUCT_WITH_VARIANTS = gql`
  query getProduct($id: ID!) {
    product(id: $id) {
      id
      variants {
        id
        variantId
        options
      }
      optionValues {
        id
        isEnabled
        accountingId
        variantIds
        optionValueIds
        optionValues
        modifiers {
          id
          type
          stringModifier
          priceChange {
            roundUp
            currency
            value
            includesTax
            taxPercent
          }
        }
      }
    }
  }
`
